import { UPDATE_SERVICE } from "../../routes";
import customAxios from "../../customAxios";
import { IUpdateService } from "../../../types/service.interface";

const updateService = async (formData: IUpdateService) => {
  try {
    return (
      await customAxios.put(UPDATE_SERVICE, {
        ...formData,
        serviceId: formData.serviceId,
        company: formData.company?._id,
        student: formData.student?._id,
        parent: formData.parent?._id,
        driver: formData.driver?._id,
        school: formData.school?._id,
        companyIsApprroved: true,
        cycle: formData.cycle,
        _id: formData?.serviceId,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_SERVICE: error });
    return false;
  }
};

export default updateService;
